import { render, staticRenderFns } from "./MemberHasDetach.vue?vue&type=template&id=6f57a47c&scoped=true&"
import script from "./MemberHasDetach.vue?vue&type=script&lang=ts&"
export * from "./MemberHasDetach.vue?vue&type=script&lang=ts&"
import style0 from "./MemberHasDetach.vue?vue&type=style&index=0&id=6f57a47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f57a47c",
  null
  
)

export default component.exports